// @flow

import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import SMConst from 'frontend_core/dist/constants/sm-const'
import Button from 'components/atoms/Button'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'

const Text = styled.pre`
  margin-top: ${spacing.medium_2}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1.454;
  white-space: pre-wrap;
`
const LinktextWrapper = styled.p`
  margin-top: ${spacing.medium}px;
  text-align: center;
`
const ReservationMethodLinkTextWrapper = styled.p`
  margin-top: ${spacing.small_2}px;
`

function getButtonText(
  props: PropTypes,
): ?{ title: string, onClick?: Function } {
  if (props.hasChangeRequestFromUser) {
    return {
      title: i18n.t('page.dashboard.inbox.confirmChangeReservation'),
      onClick: props.onClickConfirmChangeReservation,
    }
  } else if (props.hasChangeRequestFromOwner) {
    return {
      title: i18n.t('page.dashboard.inbox.confirmChangeReservationFromHost'),
      onClick: props.onClickConfirmChangeReservationFromHost,
    }
  } else if (props.canBeEdited) {
    return {
      title: i18n.t('page.dashboard.reservation.changeReservation'),
      onClick: props.onClickChangeReservation,
    }
  }

  return null
}

type PropTypes = {
  canBeCancelled: boolean,
  canBeEdited: boolean,
  hasChangeRequestFromOwner: boolean,
  hasChangeRequestFromUser: boolean,
  changeEndedAt: moment | Date | string,
  onClickCancel?: Function,
  onClickChangeReservation?: Function,
  onClickConfirmChangeReservation?: Function,
  onClickConfirmChangeReservationFromHost?: Function,
}

export default function ReservationRequestBlock(props: PropTypes) {
  const button = getButtonText(props)
  return (
    <div>
      {button && (
        <Button
          buttonType="medium"
          colorType="blue"
          tag="anchor"
          href="#"
          onClick={button.onClick}
          fullWidthSp
        >
          {button.title}
        </Button>
      )}
      {props.canBeCancelled && (
        <LinktextWrapper>
          <LinkText href="#" onClick={props.onClickCancel}>
            {i18n.t('page.dashboard.reservation.reservationCancel')}
          </LinkText>
        </LinktextWrapper>
      )}
      {button && (
        <React.Fragment>
          <Text>
            {i18n.t('page.dashboard.reservation.changeReservationPeriodDesc', {
              dateText: moment(props.changeEndedAt).format(
                i18n.t('page.shared.dateFormat_MD'),
              ),
            })}
          </Text>
          <ReservationMethodLinkTextWrapper>
            <LinkText
              href="https://help.spacemarket.com/hc/ja/articles/115004047428"
              target="_blank"
            >
              {i18n.t('page.dashboard.reservation.howToChangeReservation')}
              <Icon className="fa fa-angle-right" positionType="right" />
            </LinkText>
          </ReservationMethodLinkTextWrapper>
        </React.Fragment>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationRequestBlock/index.jsx